// extracted by mini-css-extract-plugin
export default {"container":"iB-z","dimension":"jB-z","dimensionLabels":"kB-z"};